import Cookies from 'js-cookie';

export const getCookieParam = (cookieName: string, param?: string): string | undefined => {
  try {
    const cookie = Cookies.get(cookieName);

    if (!cookie) {
      return undefined;
    }

    if (!param) {
      return cookie;
    }

    const cookieObj = JSON.parse(decodeURIComponent(cookie));

    return cookieObj[param];
  } catch (error) {
    return undefined;
  }
};
